// src/config/features.js
// Feature flag configuration for dashboard functionality

export const features = {
  sipSetup: true
};

export const isFeatureEnabled = (flag) => Boolean(features[flag]);
